/* eslint-disable */
      module.exports = { env : 'production', publicPath :'undefined/v/dist/' };
      